import React from 'react'

export default ({ data }) => !data.name ? null : (
  <div>
    <h1 className='Sidebar__head Sidebar__head_top'><a href={data.webSite} className='Link Link_light'>{data.name}</a></h1>
  </div>
)

/*
import Share from '../Sidebar/Share'
import SidebarFooter from '../Sidebar/Footer'
const stripHttp = value => value.replace(/(^\w+:|^)\/\//, '')
<SidebarFooter
  Left={<Share />}
  Right={
    <div className='Sidebar__logo'>
      {data.logo && (
        <div className='Sidebar__logo-img'>
          <img src={data.logo} alt={data.name} />
        </div>
      )}
        {!data.logo && (<span className='Sidebar__logo-label'>{data.name}</span>)}
      {data.webSite && <a href={data.webSite} className='Sidebar__logo-label Link Link_light'>{stripHttp(data.webSite)}</a>}
    </div>
  }
/>
*/



// WEBPACK FOOTER //
// ./src/components/Fund/Sidebar.jsx